import React from 'react';
import { connect } from 'react-redux';
import { addToCart } from './actions/';
import CartButton from './CartButton';
import BackgroundText from './BackgroundText';
import styles from './assets/styles/main.css';

const products = [
	{
        id: 1,
        name: 'T shirt 1',
        price: 70,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 2,
        name: 'T shirt 2',
        price: 40,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 3,
        name: 'T shirt 3',
        price: 20,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 4,
        name: 'T shirt 4',
        price: 130,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    }
];

class SingleProduct extends React.Component{

	handleClick = (id) => {
		this.props.addToCart(id)
	}

	render(){

		const product = (() => {
			for(var i = 0; i < products.length; i++){
				if(products[i].id === Number(window.location.href.split('?')[1].split('=')[1])){
					return products[i]
				}
			}
		})()




		return (

			<div id = 'singleProduct'>
				<BackgroundText text = {'React Ecommerce Store'} />
				<div className = 'container'>
					<div className = 'row'>
						<div className = 'col-lg-5'>
							<img className = 'singleProductImage' src = {product.image} />
						</div>
						<div className = 'col-lg-1'></div>
						<div className = 'col-lg-6'>
							<h2>{product.name}</h2>
							<p>{product.description}</p>
							<h5>{`$${product.price}`}</h5>
							<CartButton clickHandler = {() => {this.handleClick(product.id)}}/>
						</div>
					</div>
				</div>
			</div>

		)
	}
}

const mapDispatchToProps= (dispatch)=>{
    return{
        addToCart: (id)=>{dispatch(addToCart(id))}
    }
}

export default connect(null, mapDispatchToProps)(SingleProduct)